module.exports = __webpack_public_path__ + "img/status-end.8ae15ac4.svg";